"use client"

import { Layer } from "effect"
import { AppHttpClient } from "@/shared/scope"
import { RpcClient, RpcSerialization } from "@effect/rpc"
import { createEffectQueryNoAbort } from "@/lib/api/effect-query-utils"
import { ChatRpc } from "@/contexts/chat/presentation/chat-rpc"

const ChatRpcLive = RpcClient.layerProtocolHttp({ url: "/api/rpc/chat" }).pipe(
  Layer.provide(AppHttpClient.layer),
  Layer.provideMerge(RpcSerialization.layerJson),
)

export const chatEq = createEffectQueryNoAbort(ChatRpcLive)
export { ChatRpc }
